import MenuIcon from "../../assets/icons/menu";
import { Link, useLocation } from "react-router-dom";
import { useLeapSdk } from "../../context/sdk";
import "./app.css";
import { Box, Button, Group, Menu, Modal, Text } from "@mantine/core";
import { useClipboard, useDisclosure } from "@mantine/hooks";
import { useCallback, useEffect, useState } from "react";

export default function App() {
  const [opened, handlers] = useDisclosure(false);
  const { pathname } = useLocation();
  const { user, loading, leapSdk, setUser } = useLeapSdk();
  const hideLogin = pathname === "/login";
  const handleLoginClick = useCallback(() => {
    handlers.open();
  }, []);
  return (
    <>
      <header className="header">
        <nav>
          <Link to="/">
            <img
              src="https://softr-prod.imgix.net/applications/95bf8384-8d1e-46c0-9e2f-d2d8ee183230/assets/1aa6328e-a6fd-4754-a36c-5c2b04452ccd.svg"
              alt="leap wallet logo"
              className="logo"
            />
          </Link>
          <Box
            sx={{
              display: "flex",
              columnGap: "32px",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            {loading ? null : user ? (
              <UserInfo user={user} leapSdk={leapSdk} setUser={setUser} />
            ) : hideLogin ? null : (
              <button className="login" onClick={handleLoginClick}>
                Login
              </button>
            )}
            {user ? (
              <>
                <Link to="/nfts" className="login">
                  NFTs
                </Link>
                <a
                  target="_blank"
                  href="https://widget.onramper.com/"
                  rel="noreferrer"
                >
                  Buy/Sell
                </a>
              </>
            ) : null}
            <a
              target="_blank"
              href="https://docs.leapwallet.io/evm-js-sdk/"
              rel="noreferrer"
            >
              Docs
            </a>
            <Link to="/roadmap">Roadmap</Link>
          </Box>
        </nav>
      </header>
      <ChooseLoginService opened={opened} handlers={handlers} />
    </>
  );
}

export const UserInfo = ({ user, leapSdk, setUser }) => {
  const [opened, setOpened] = useState(false);
  const walletAddress = user.address;
  const [balance, setBalance] = useState(0);
  const { copy, copied } = useClipboard({ timeout: 500 });
  useEffect(() => {
    async function getBalance() {
      const balance = await leapSdk.provider.getBalance(walletAddress);
      setBalance(+balance.toString() / 10 ** 18);
    }
    if (walletAddress) {
      getBalance();
    }
  }, [walletAddress, opened, leapSdk.provider]);
  return (
    <>
      <Menu trigger="click" onChange={(val) => setOpened(val)}>
        <Menu.Target>
          <div className="wallet-address-btn">
            <img
              src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=retro"
              alt="icon"
              width="24"
              height="24"
              className="user-icon"
            />
            <span>{`${walletAddress?.slice(0, 16)}...${walletAddress?.slice(
              -4
            )}`}</span>
            <MenuIcon />
            <Menu.Dropdown
              sx={{
                backgroundColor: "rgb(46, 46, 46, 0.5)",
                border: "none",
                width: "100%",
                padding: "12px",
                textAlign: "left",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Button
                  variant="filled"
                  sx={{
                    padding: "4px",
                    fontSize: "12px",
                    borderColor: "#242526",
                    height: "fit-content",
                    color: "#fff",
                    fontWeight: 500,
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    copy(walletAddress);
                  }}
                >
                  {copied ? "copied" : "copy"}
                </Button>
              </Box>
              <Box sx={{ display: "grid", rowGap: "12px" }}>
                <Box
                  sx={{
                    padding: "8px 12px",
                    borderRadius: "8px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Text sx={{ textTransform: "capitalize", fontWeight: 600 }}>
                    Balance
                  </Text>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "8px",
                    }}
                  >
                    <img
                      src="https://cdn3d.iconscout.com/3d/premium/thumb/money-3597246-3010226.png"
                      alt="balance icon"
                      width="16px"
                      height="16px"
                    />
                    <Text sx={{ textTransform: "capitalize", fontWeight: 600 }}>
                      {balance}
                    </Text>
                  </Box>
                </Box>
                <Box
                  sx={{
                    backgroundColor: "#000",
                    padding: "8px 12px ",
                    borderRadius: "8px",
                    fontSize: "12px",
                  }}
                >
                  <Text sx={{ textTransform: "capitalize", fontWeight: 600 }}>
                    {user.loginProvider}
                  </Text>
                  <Text sx={{ fontWeight: "bold" }}>{user.email}</Text>
                </Box>
                <Button
                  variant="outline"
                  sx={{
                    borderColor: "#242526",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                  onClick={async () => {
                    await leapSdk.auth.logout({ cleanup: true });
                    localStorage.clear();
                    setUser(null);
                  }}
                >
                  Sign Out
                </Button>
              </Box>
            </Menu.Dropdown>
          </div>
        </Menu.Target>
      </Menu>
    </>
  );
};

const ChooseLoginService = ({ opened, handlers }) => {
  const handleClick = (type) => {
    localStorage.setItem("login_service", type);
    handlers.close();
    window.location.replace("/login");
  };
  return (
    <Modal
      opened={opened}
      onClose={() => handlers.close()}
      title="Choose login service"
      centered
      withCloseButton={false}
      overlayOpacity={0.8}
    >
      <Group position="center" align="center" spacing="48px">
        <Button onClick={() => handleClick("ramper")}>Ramper</Button>
        <Button onClick={() => handleClick("web3auth")}>Web3Auth</Button>
      </Group>
    </Modal>
  );
};
